import { createReducer, on } from "@ngrx/store";
import { login, loginError, loginSuccess, logout } from "./auth.actions";

export const initialLogin = {
    isAuth: false,
    isAdmin: false,
    isSuperAdmin: false,
    user: undefined,
    groups: [],
    groupsDescription: [],
    loading: false
}

const initialState = JSON.parse(sessionStorage.getItem('login') || JSON.stringify(initialLogin));

export const authReducer = createReducer(
    initialState,
    on(login, (state, { username, password }) => (
        {
            isAuth: state.isAuth,
            isAdmin: state.isAdmin,
            isSuperAdmin: state.isSuperAdmin,
            user: state.user,
            groups: state.groups,
            groupsDescription: state.groupsDescription,
            loading: true
        }
    )),
    on(loginSuccess, (state, { login }) => (
        {
            isAuth: true,
            isAdmin: login.isAdmin,
            isSuperAdmin: login.isSuperAdmin,
            user: login.user,
            groups: login.groups,
            groupsDescription: login.groupsDescription,
            loading: false
        }
    )),
    on(logout, (state) => ({... initialLogin})),
    on(loginError, (state) => ({... initialLogin}))
)